import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { cx } from '@emotion/css'
import { colors } from '@offerzen/pinata'
import ChevronRightIcon from '@offerzen/zenicon/ChevronRightIcon'
import AccessibleIcon from '../AccessibleIcon'
import styles from './styles'

const Breadcrumb = ({ path, className }) => (
  <ul className={cx(styles.wrapper, className)}>
    {path.map((el, index) => {
      let crumb = el.label
      if (el.href) {
        crumb = el.external ? <a href={el.href}>{el.label}</a> : <Link to={{ pathname: el.href, state: el.state }}>{el.label}</Link>
      }
      return (
        <li key={el.href || 'current'}>
          {index > 0 && <AccessibleIcon icon={ChevronRightIcon} color={colors.grayChateau} size="20px" className={styles.icon} />}
          {crumb}
        </li>
      )
    })}
  </ul>
)

Breadcrumb.propTypes = {
  path: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string,
      external: PropTypes.bool,
      state: PropTypes.shape({}),
    }),
  ).isRequired,
  className: PropTypes.string,
}

export default Breadcrumb
